<template>
    <div>
        <div v-if="participantList && participantList.length > 0">
          <div v-for="(part, i) in participantList" :key="part.userId || part.id || i" class="ml-2 mr-2 mb-2">
            <v-card class="elevation-4" :style="`background:${cardBGColor}`">
              <v-card-text>
                <v-row no-gutters>
                  <v-col md="6" sm="3" class="text-left" style="position:relative">
                    <HeaderCard :part="part"/>
                  </v-col>
                  <v-col md="6" sm="9" class="text-right">
                    <v-btn
                      :color="`${buttonColor}`"
                      dark
                      @click="openDialog(part, null, 'AMA')"
                      class="mr-2"
                    >{{ $tc("membership.add_ama_button") }}</v-btn>
                      <v-btn v-for="item in organizationsAvailableForAma" :key="item.organizationMemberTypeId"
                        :color="`${buttonColor}`"
                        dark
                        @click="openDialog(part, item, item.organizationName)"
                      >{{ $tc("membership.classes.add") }} {{item.organizationName.length > 0 ? item.organizationName : item.name}}
                      </v-btn>
                    
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="12">
                      <v-data-table
                        :headers="membershipHeaders"
                        :items="part.memberships || []"
                        sort-by="name"
                        class="elevation-1"
                        dense
                        :no-data-text="$tc('membership.no_data_available')"
                        :footer-props="{
                          'items-per-page-text': $tc(
                            'membership.items_per_page_text'
                          ),
                        }"
                      >
                        <template v-slot:[`item.view`]="{ item }">
                          <v-icon small class="mr-2" @click="viewHistory(item)">fa far fa-credit-card</v-icon>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon v-if="item.selfRegistration" small :title="$tc('membership.delete')" @click="deleteItem(item)">fa far fa-trash-alt</v-icon>
                          <v-btn 
                            v-if="item.status == 1 && !item.selfRegistration && item.allowPublicView && item.expired && !item.isAma && item.allowSignup"
                            @click="renew(item)"
                            :color="`${buttonColor}`"
                            dark
                            class="mb-1 mt-1 btn1 btn2"
                          >{{ $tc('membership.renew') }}</v-btn>
                          <v-btn
                            v-if="canShowSignWaiverButton(part, item)"
                            :color="`${buttonColor}`"
                            small
                            class="mb-1 mt-1 btn1 btn2 white--text"
                            @click="signWaiverNow(part, item)"
                          >
                            {{ $t('registerEvent.sign_waiver_now') }}
                          </v-btn>
                        </template>
                      </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
           </div>
        </div>
        <div v-else class="text-center pa-4">
          <p>{{ $tc('dataTable.noDataText') }}</p>
        </div>
    </div>
</template>

<script>
import HeaderCard from "@/components/HeaderCard";
import { mapState } from "vuex";
import { VCard, VCardText, VRow, VCol, VDataTable, VIcon, VBtn } from 'vuetify/lib';
export default {
  name: 'MembershipTable',
  components: {
    HeaderCard, VCard, VCardText, VRow, VCol, VDataTable, VIcon, VBtn
  },
  props: {
    participantList: {
      type: Array,
      required: true,
      default: () => []
    },
    organizationsAvailableForAma:{
      type: Array,
      required: true,
      default: () => []
    },
    signWaiverAvailability: {
      type: Object,
      required: false,
      default: () => ({})
    },
    organizationHasWaiverDocuments: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      buttonColor: "#000",
      cardBGColor: "#f1f1f1",
      borderAlertColor: "",
      iconAlertColor: "",
      bgAlertColor: ""
    }
  },
  computed: {
    ...mapState({
      userStore: (state) => state.session.user
    }),
    membershipHeaders() {
      return [
        {
            text: this.$t("membership.card"),
            value: "view",
            sortable: false
        },
        {
          text: this.$t("membership.organization_name"),
          align: "",
          sortable: false,
          value: "organizationName"
        },
        { text: this.$t("membership.class"), value: "className" },
        { text: this.$t("membership.race_num"), value: "raceNumber" },
        { text: this.$t("membership.membership_number"), value: "membershipNumber" },
        {
          text: this.$t("membership.membership_expiration"),
          value: "validTo"
        },
        {
          text: this.$t("membership.membership_type"),
          value: "membershipTypeName",
          sortable: false
        },
        {
          text: this.$t("membership.event_name"),
          value: "membershipEventName",
          sortable: false
        },
        {
          text: this.$t("membership.actions"),
          value: "actions",
          sortable: false
        }
      ];
    }
  },
  methods: {
    openDialog(part, item, organizationName) {
      this.$emit('openDialog', part, item, organizationName);
    },
    viewHistory(item) {
      this.$emit('viewHistory', item);
    },
    deleteItem(item) {
      this.$emit('deleteItem', item);
    },
    renew(item) {
      this.$emit('renew', item);
    },
    isAdultParticipant(participant) {
      if (!participant) {
        return null;
      }

      const birthday = participant.birthDate || participant.birthday;
      if (!birthday) {
        return null;
      }

      const birthDate = new Date(birthday);
      if (Number.isNaN(birthDate.getTime())) {
        return null;
      }

      const adultLimit = new Date();
      adultLimit.setFullYear(adultLimit.getFullYear() - 18);
      return birthDate <= adultLimit;
    },
    canShowSignWaiverButton(participant, membership) {
      if (!participant || !participant.userId || !membership?.organizationId || !this.userStore || !this.userStore.id) {
        return false;
      }
      
      if (!this.organizationHasWaiverDocuments?.[membership.organizationId]) {
        return false;
      }

      const hasUnsignedWaiver = !!this.signWaiverAvailability?.[participant.userId]?.[membership.organizationId];
      if (!hasUnsignedWaiver) {
        return false;
      }

      const isOwnUser = participant.userId === this.userStore.id;
      if (isOwnUser) {
        return true;
      } 

      // For linked accounts, only allow signing for minors.
      const isAdult = this.isAdultParticipant(participant);
      if (isAdult === true) {
        return false;
      }

      if (isAdult === false) {
        return true;
      }

      // If age cannot be determined, do not show for third parties.
      return false;
    },
    signWaiverNow(participant, membership) {
      this.$emit('signWaiverNow', participant, membership);
    }
  },
  created: function() {
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.cardBGColor = this.$store.getters.env.get('VUE_APP_BACKGROUND_CARD_PART');
    this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');
    this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');
    this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');
  }
}
</script>
